import constants from 'constants/constants';
import moment from 'moment-timezone';

import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';

import { CustomizedTooltip } from 'components/common';
import classes from 'components/widgets/ProjectScorecards/components/PredictionDateCell/PredictionDateCell.module.scss';

interface Props {
    date: number;
    variance: number;
    milestone: string;
    taskId: string;
}
export const PredictionDateCell = ({ date, variance, milestone, taskId }: Props) => {
    return (
        <div>
            <CustomizedTooltip
                tooltipPosition={TooltipPosition.Bottom}
                tooltipContent={
                    <>
                        <div>
                            Predicted milestone:{' '}
                            <span className={classes.result}>
                                {milestone} ({taskId})
                            </span>
                        </div>
                    </>
                }
                triggerElement={
                    <>
                        <div>{moment(date).format(constants.formats.date.default)}</div>
                        <div className={classes.subTitle}>{variance} days</div>
                    </>
                }
            />
        </div>
    );
};
